// offlineQueueUtils.js

// ---- Cache Names ----
export const CACHE_APP_DATA = 'app-data';
export const CACHE_MASTER_DATA = 'master-data';

export const CACHE_KEY_MAP = {
  DAILY_PLANNER_URL: "/daily-planner",
  BOTTLE_TRACKER_URL: "/bottle-tracker",
  FIELD_ITEMS_URL: "/field-items",
  FIELD_ITEMS_VERIFY_URL: "/field-items-verify",
  FIELD_ITEMS_STATUS_URL: "/field-items-status"
};

export const ToolsAndEquiment = {
  equipmentIds: [],
  chemicalIds: [],
  supplyIds: []
};

export const CategoryToToolKey = {
  equipment: "equipmentIds",
  chemicals: "chemicalIds",
  supplies: "supplyIds"
};

export const EquipmentCategoryMap = {
  EQUIPMENT: "equipment",
  CHEMICAL: "chemicals",
  CHEMICALS: "chemicals", // singular matches payload
  SUPPLY: "supplies",
  SUPPLIES: "supplies"
};

export const EntityAssignmentMap = {
  EQUIPMENT: { key: "equipment", typeField: "equipType" },
  CHEMICAL: { key: "chemicals", typeField: "chemicalType" },
  SUPPLY: { key: "supplies", typeField: "supplyType" },
  SUPPLIES: { key: "supplies", typeField: "supplyType" }
};


export const OfflineSyncStatus = Object.freeze({
  PENDING: 'PENDING',
  IN_PROGRESS: 'IN_PROGRESS',
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
  RETRYING: 'RETRYING',
  CANCELLED: 'CANCELLED'
});

export const EntityType = Object.freeze({
  TASK: '1',
  CUSTODY_TRAIL: '2',
  CALIBRATION: '3',
  VERIFICATION: '4',
  FIELD_ITEMS: '5'
});

export const ActionType = Object.freeze({
  INSERT: '1',
  FORM_UPDATE: '2',
  STATUS_UPDATE: '3',
  DELETE: '4',
  TRANSFER: '5',
  FIELD_ITEMS_UPDATE: '6',
  VERIFY: '7'
});

const KEY_DELIMITER = '%';

const entityLabels = {
  [EntityType.TASK]: 'Task',
  [EntityType.CUSTODY_TRAIL]: 'Custody Trail',
  [EntityType.CALIBRATION]: 'Calibration',
  [EntityType.VERIFICATION]: 'Verification',
  [EntityType.FIELD_ITEMS]: 'Field Items'
};

const actionLabels = {
  [ActionType.INSERT]: 'Insert',
  [ActionType.FORM_UPDATE]: 'Form Update',
  [ActionType.STATUS_UPDATE]: 'Status Update',
  [ActionType.DELETE]: 'Delete',
  [ActionType.TRANSFER]: 'Transfer',
  [ActionType.FIELD_ITEMS_UPDATE]: 'Assign',
  [ActionType.VERIFY]: 'Add'
};

export const getDisplayStringFromKey = (key) => {
  if (!key) return '';

  const [entityType, actionType, id] = key.split(KEY_DELIMITER);

  const entity = entityLabels[entityType] || `Unknown Entity (${entityType})`;
  const action = actionLabels[actionType] || `Unknown Action (${actionType})`;

  const shouldShowId = !['3', '4', '5'].includes(entityType);
  return `${entity} - ${action}${shouldShowId && id ? ` (ID: ${id})` : ''}`;
};

export const getEntityKey = (entityType, actionType, id = "") => {
  return [entityType, actionType, id].join(KEY_DELIMITER);
};

